export { default as ContrastSolidIcon } from './ContrastSolidIcon';
